import React from "react";
import ButtonOrange from "@shared/uiNew/Button/button_orange";
import * as styles from "./Closing.module.scss";
import { closingShared, REGISTER_URL } from "@shared/arrays/dashly-vs";

/**
 * The page's single dark block, so it carries the chartreuse glow the design
 * system puts on dark sections.
 */
export function Closing() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <p className={styles.lead}>{closingShared.lead}</p>
        <h2 className={styles.title}>{closingShared.title}</h2>
        <p className={styles.text}>{closingShared.text}</p>

        <ButtonOrange
          icon="arrow"
          text={closingShared.cta}
          href={REGISTER_URL}
          type="link"
        />

        <p className={styles.note}>{closingShared.note}</p>
        {/* The export's own line about support hours; it is not in the product
            knowledge base, so it stays as copy and never becomes a heading. */}
        <p className={styles.support}>
          {closingShared.supportIcons.map((src) => (
            <img key={src} src={src} alt="" aria-hidden="true" loading="lazy" />
          ))}
          {closingShared.supportLine}
        </p>
      </div>
    </section>
  );
}

export default Closing;
